export default class FeedbackTableFiltersViewModel {
    public flagTeamLeader: boolean = true;
    public flagChannel: boolean = false;
    public flagAgentName: boolean = false;
    public flagClient: boolean = true;
    public flagStatus: boolean = true;
    public flagAlert: boolean = false;
    public flagResult: boolean = false;
    public flagCompletionToday: boolean = false;
    public flagCompletionYesterday: boolean = false;
    public flagCompletionThisWeek: boolean = false;
    public flagCompletionLastWeek: boolean = false;
    public flagCompletionSingleDate: boolean = false;
    public flagCompletionDateRange: boolean = false;
    public flagCompletionTimeRange: boolean = false;
    public flagMonitoringStatus: boolean = true;
    public flagMonitoredBy: boolean = false;
    public flagScorecardType: boolean = false;
    public teamLeader: string[] = [];
    public channel: string = '';
    public agentName: string[] = [];
    public client: string = '';
    public status: string[] = ['Pending', 'Awaiting Feedback'];
    public alert: string = '';
    public result: string = '';
    public completionStartDate: Date = new Date();
    public completionEndDate: Date = new Date();
    public completionStartTime: string = '';
    public completionEndTime: string = '';
    public monitoringStatus: string = 'Completed';
    public monitoredBy: string[] = [];
    public scorecardType: string = ''

    constructor(client: string, teamLeader: string[], view: string) {
        this.client = client;
        this.teamLeader = teamLeader;
        this.status = defaultStatusFilters.find(f => f.view.includes(view))?.status ?? [];
    }
}

const defaultStatusFilters = [
    {
        status: [
            'Feedback Challenged',
            'Challenge Upheld'
        ],
        view: ['QA Team Leader']
    },
    {
        status: [
            'Pending',
            'Awaiting Feedback'
        ],
        view: ['Team Leader', 'QA']
    },
    {
        status: [
            'QA Approval Required'
        ],
        view: ['Team Leader Scorecards']
    }
];